import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ContractorService } from 'app/_services/contractor.service';
import { NotificationService } from 'app/_services/notification.service';
import { SiteOwnerUserService } from 'app/_services/site-owner-user.service';

@Component({
  selector: 'add-contractor-site-owner-link-modal',
  templateUrl: './add-contractor-site-owner-link-modal.component.html'
})
export class AddContractorSiteOwnerLinkModalComponent implements OnInit {
  public form: FormGroup;
  public contractors: any[] = [];
  public siteOwners: any[] = [];

  constructor(
    private activeModal: NgbActiveModal,
    private formBuilder: FormBuilder,
    private contractorService: ContractorService,
    private siteOwnerSerivce: SiteOwnerUserService,
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
    this.form = this.formBuilder.group({
      contractor: new FormControl('', Validators.required),
      siteOwner: new FormControl('', Validators.required),
    });

    this.contractorService.getAllContractorFullList().subscribe((data: any) => {
      this.contractors = data.map((element) => ({
        label: element.name,
        value: element.id,
      }));
    });

    this.siteOwnerSerivce.getAllEnabledSiteOwnersForDropdowns().subscribe((data: any) => {
      this.siteOwners = data.map(element => ({
        label: element.siteOwnerUser.name,
        value: element.id,
      }))
    });
  }

  public closeModal() {
    this.activeModal.dismiss();
  }

  public onSubmit() {
    const values = this.form.value;

    const body = {
      maintenanceId: values.contractor,
      siteOwnerSkylarkId: values.siteOwner,
    };

    this.contractorService.createContractorSiteOwnerLink(body).subscribe(() => {
      this.notificationService.notify('success', 'Contractor - Site Owner Link Created');

      this.activeModal.close('refresh');
    }, error => {
      console.error(error);
      this.notificationService.notify('danger', 'Could not create link, may already exist');

      throw error;
    });
  }
}
